import 'css-chunk-1JavaScriptSource/components/_Dialogs/ImportSvgResolverDialog/style.module.scss';export default {
  "importDialog": "_importDialog_11hyp_1",
  "resolverWrapper": "_resolverWrapper_11hyp_5",
  "resolverSection": "_resolverSection_11hyp_9",
  "confirmButtons": "_confirmButtons_11hyp_14"
};